(function ($, Drupal) {
  'use strict';
  Drupal.behaviors.nsbforms = {
    attach: function (context, settings) {
      $('input[value!=""]').closest('.input_wrapper').addClass('notempty');
      if ($('textarea').val()) {
        $(document).closest('.input_wrapper').addClass('notempty');
      }
    }
  };

  $(document).ready(function () {
    //label input position
    $('input[value!=""]').not('[type="password"]').closest('.form-item').addClass('notempty');
    $(document).on("change keyup focus blur mousedown touch input", "input", function () {
      var that = $(this);
      that.closest('.form-item').addClass("notempty");
    });

    $(document).on("blur", "input", function () {
      var that = $(this);
      if (that.val() == "") {
        that.closest('.form-item').removeClass("notempty");
      }
    });
    $(document).on("change keyup focus blur mousedown touch input", ".form-item textarea", function () {
      var that = $(this);
      that.closest('.form-item').addClass("notempty");
    });
    $(document).on("blur", ".form-item textarea", function () {
      var that = $(this);
      if (that.val() == "") {
        that.closest('.form-item').removeClass("notempty");
      }
    });

    }//document ready
  );//document ready


})(jQuery, Drupal);
